<!-- その他営業収入の現金回収の登録 -->
<template>
  <el-table
    :data="blendData"
    class="egl-table"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    stripe
  >
    <el-table-column
      prop="clientId"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.customerName')"
      align="center"
    >
      <template slot-scope="scope">
        <!-- <el-select
          v-if="!scope.row.totalRow"
          v-model="tableData[scope.$index].clientId"
          :placeholder="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.selectPlaceHolder')"
          :filterable="true"
          :clearable="true"
        >
          <el-option
            v-for="item in clientList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <!-- <template v-if="isOpen">
          <remote-select
            v-if="!scope.row.totalRow"
            type="client"
            v-model="tableData[scope.$index].clientId"
            :formValue.sync="tableData[scope.$index].clientId"
            :isMultiple="false"
            :actionType="$attrs.actionTypeC"
            :isDayClose="true"
          ></remote-select>
          <div v-else class="ta-r">{{ $locale("accountReceivable.totalAmount") }}</div>
        </template> -->
        <RemoteSelectV2
          v-if="!scope.row.totalRow"
          ref="selectV2Client"
          type="client"
          :list="comClientList"
          v-model="scope.row.clientId"
          :isMultiple="false"
          :formValue.sync="scope.row.clientId"
          :fields="['id', 'name']"
          @setList="arr => comClientList = arr"
        />
        <div v-else class="ta-r">{{ $locale("accountReceivable.totalAmount") }}</div>
      </template>
    </el-table-column>
    <el-table-column
      prop="otherRevenueId"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.itemName')"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-model="tableData[scope.$index].otherRevenueId"
          :placeholder="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.selectPlaceHolder')"
          :clearable="true"
          @change="value => changeAction(value, scope.$index)"
        >
          <el-option
            v-for="item in otherRevList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column
      prop="price"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.unitPrice')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="!scope.row.totalRow"
          :value="tableData[scope.$index].price | currencyFormatter"
          maxlength="14"
          @input="value => inputAction(value, scope.$index, 'price')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column
      prop="qty"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.qty')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="!scope.row.totalRow"
          :value="tableData[scope.$index].qty | separatorFormatter"
          maxlength="10"
          @input="value => inputAction(value, scope.$index, 'qty')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column
      prop="unit"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.unit')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="!scope.row.totalRow"
          v-model="tableData[scope.$index].unit"
          maxlength="30"
        ></el-input>
        <template v-else>{{ scope.row.unit }}</template>
      </template>
    </el-table-column>

    <el-table-column
      prop="cashRecovery"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.cashCollectionAmount')"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.cashRecovery | currencyFormatter(true) }}
      </template>
    </el-table-column>

    <el-table-column
      prop="details"
      :label="$locale('dailyClosing.createDialog.otherCashCollectionRegistrationTable.th.details')"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="!scope.row.totalRow"
          v-model="tableData[scope.$index].details"
          maxlength="100"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column>
      <template slot-scope="scope">
        <div class="handle ctrl">
          <el-button
            v-if="tableData.length > 1 && scope.$index < tableData.length"
            class="handle-btn egl-btn-white"
            icon="el-icon-minus"
            @click="removeTableDataAction(scope.$index)"
          ></el-button>
          <el-button
            v-if="scope.$index === tableData.length - 1"
            class="handle-btn egl-btn-white"
            icon="el-icon-plus"
            @click="addTableDataAction"
          ></el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { digtalParser } from "@/utils/common";
import { otherCashRecoveryBaseStruct } from "@/assets/js/dailyClosingNew";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";

export default {
  name: "OtherCashCollectionRegistrationTable",
  props: {
    otherRevList: {
      type: Array,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    tableData: {
      required: true,
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      comClientList: [],
    };
  },
  mounted() {
    this.comClientList = this.clientList;
  },
  computed: {
    blendData() {
      if (this.tableData.length === 0) {
        this.addTableDataAction();
      }

      let resultArray = tranfResData(this.tableData);
      let _total = 0;

      resultArray.forEach(_item => {
        const _subTotal = Number(_item.price) * _item.qty;
        _item.cashRecovery = _subTotal;
        _total += _subTotal;
      });

      const _base = otherCashRecoveryBaseStruct();
      resultArray.push({
        ..._base,
        totalRow: true,
        cashRecovery: _total,
      });

      return resultArray;
    },
  },
  methods: {
    inputAction(value, idx, key) {
      let _value = digtalParser(value);

      if (this.tableData[idx]) {
        this.tableData[idx][key] = _value;
        if (key === "qty") {
          this.tableData[idx].cashRecovery = this.tableData[idx].price * _value;
        } else if (key === "price") {
          this.tableData[idx].cashRecovery = _value * this.tableData[idx].qty;
        }
      }
    },
    rowClassName({ row }) {
      if (row.totalRow) {
        return "total-row";
      }
      return "";
    },
    spanMethod({ columnIndex, row }) {
      if (row.totalRow) {
        if (columnIndex === 0) {
          return [1, 5];
        } else if (columnIndex < 5) {
          return [0, 0];
        }
      }
    },
    addTableDataAction() {
      const _base = otherCashRecoveryBaseStruct();
      this.tableData.push(_base);
    },
    removeTableDataAction(index) {
      this.tableData.splice(index, 1);
    },
    changeAction(id, index) {
      const _targetData = this.tableData[index];

      if (id) {
        const _targetItem = this.otherRevList.find(_item => _item.id === id);

        if (_targetItem) {
          const _targetData = this.tableData[index];
          _targetData.price = _targetItem.price;
          _targetData.qty = _targetItem.inventory;
          _targetData.unit = _targetItem.unit;
          _targetData.cashRecovery = _targetItem.cashRecovery || _targetItem.price * _targetItem.inventory;
        }
      } else {
        _targetData.price = 0;
        _targetData.qty = 0;
        _targetData.unit = "";
        _targetData.cashRecovery = 0;
        _targetData.details = "";
      }
    },
  },
  components: {
    RemoteSelectV2
  }
};
</script>
